import './index.css';
import React from 'react';

const DommusRequiredSpan = (props) => {
	return <span className="help-text" style={{color: props.color ?? 'red'}}>*</span>;
};

export default DommusRequiredSpan;
